// 指令骨架预定义样式标签（只创建一次）
const skeletonStyle = document.createElement('style')
skeletonStyle.textContent = `
  @keyframes hzp-skeleton-placeholder-shimmer {
    from { transform: translate3d(-100%, 0, 0) }
    to { transform: translate3d(100%, 0, 0) }
  }
  .skeleton-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    background: #f2f2f2;
    border-radius: 5px;
    z-index: 99;
    transition: opacity 0.3s ease;
  }
  .skeleton-placeholder::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: inherit;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.72), transparent);
    content: "";
    pointer-events: none;
    transform: translate3d(-100%, 0, 0);
    animation: hzp-skeleton-placeholder-shimmer 1.2s linear infinite;
  }
  @media (prefers-reduced-motion: reduce) {
    .skeleton-placeholder::before { animation: none }
  }
`
document.head.appendChild(skeletonStyle)

// 单位转换缓存
const unitCache = new Map()

// 优化后的单位转换函数（带缓存）
function toRem(value) {
  const cacheKey = `rem-${value}`
  if (unitCache.has(cacheKey)) {
    return unitCache.get(cacheKey)
  }

  let result
  if (typeof value === 'number') {
    result = `${value / 16}rem`
  } else if (typeof value === 'string' && value.endsWith('px')) {
    result = `${parseFloat(value) / 16}rem`
  } else {
    result = value
  }

  unitCache.set(cacheKey, result)
  return result
}

// 优化后的vw转换函数（带缓存）
function toVw(value) {
  const cacheKey = `vw-${value}`
  if (unitCache.has(cacheKey)) {
    return unitCache.get(cacheKey)
  }

  let result
  if (typeof value === 'number') {
    result = `${(value / 375) * 100}vw`
  } else if (typeof value === 'string' && value.endsWith('px')) {
    result = `${(parseFloat(value) / 375) * 100}vw`
  } else {
    result = value
  }

  unitCache.set(cacheKey, result)
  return result
}

// 更新骨架屏样式（优化版）
function updateSkeletonStyle(el) {
  const config = el._skeletonConfig
  if (!config || !el._skeleton) return

  const skeleton = el._skeleton

  // 批量设置样式
  const styles = {
    width: config.isMobile ? toVw(config.mobileWidth) : toRem(config.pcWidth),
    height: config.isMobile ? toVw(config.height) : toRem(config.height),
    transition: `opacity ${config.transitionDuration} ease`
  }

  Object.assign(skeleton.style, styles)
}

// Vue 3 骨架屏指令
const skeletonDirective = {
  // Vue 3 对应 mounted
  mounted(el, binding) {
    // 使用requestAnimationFrame确保初始渲染性能
    requestAnimationFrame(() => {
      // 获取绑定值，默认值设置
      const {
        pcWidth = '100%',
        mobileWidth = '100%',
        height = '100%',
        show = true,
        transitionDuration = '0.3s',
        delay = 0
      } = binding.value || {}

      // 判断是否为移动端（使用媒体查询更准确）
      const isMobile = window.matchMedia('(max-width: 768px)').matches

      // 创建骨架屏元素
      const skeleton = document.createElement('div')
      skeleton.className = 'skeleton-placeholder'

      // 设置父元素基础样式（使用class而不是直接style）
      el.classList.add('skeleton-parent')
      if (!el.style.position) {
        el.style.position = 'relative'
        el.style.boxShadow = '0px 2px 15px 0px rgba(0, 4, 255, 0)'
      }

      // 保存配置和元素引用
      el._skeletonConfig = {
        pcWidth,
        mobileWidth,
        height,
        show,
        transitionDuration,
        delay,
        isMobile
      }
      el._skeleton = skeleton
      el._skeletonTimeout = null

      // 初始化样式
      updateSkeletonStyle(el)

      // 添加到DOM
      el.appendChild(skeleton)

      // 根据show参数设置初始状态
      if (show) {
        el.style.overflow = 'hidden'
        skeleton.style.display = 'block'
        skeleton.style.opacity = '1'
      } else {
        skeleton.style.display = 'none'
        skeleton.style.opacity = '0'
      }
    })
  },

  // Vue 3 对应 updated
  updated(el, binding) {
    // 使用requestAnimationFrame批量处理更新
    requestAnimationFrame(() => {
      const oldConfig = el._skeletonConfig || {}
      const newConfig = {
        pcWidth: '100%',
        mobileWidth: '100%',
        height: '100%',
        show: true,
        transitionDuration: '0.3s',
        delay: 500,
        ...binding.value
      }

      // 更新配置
      const isMobile = window.matchMedia('(max-width: 768px)').matches
      el._skeletonConfig = {
        ...newConfig,
        isMobile
      }

      // 检查是否需要更新样式
      const needUpdateStyle = (
        newConfig.pcWidth !== oldConfig.pcWidth ||
        newConfig.mobileWidth !== oldConfig.mobileWidth ||
        newConfig.height !== oldConfig.height ||
        isMobile !== oldConfig.isMobile
      )

      if (needUpdateStyle) {
        updateSkeletonStyle(el)
      }

      // 检查是否需要切换显示状态
      if (newConfig.show !== oldConfig.show) {
        // 清除之前的延时定时器
        if (el._skeletonTimeout) {
          clearTimeout(el._skeletonTimeout)
          el._skeletonTimeout = null
        }

        if (newConfig.show) {
          el.style.overflow = 'hidden'
          el._skeleton.style.display = 'block'
          // 强制重绘确保动画流畅
          void el._skeleton.offsetHeight
          el._skeleton.style.opacity = '1'
        } else {
          const hideSkeleton = () => {
            el._skeleton.style.opacity = '0'
            setTimeout(() => {
              el._skeleton.style.display = 'none'
              el.style.overflow = ''
              el.style.boxShadow = ''
            }, parseFloat(newConfig.transitionDuration || '0.3') * 1000)
          }

          if (newConfig.delay > 0) {
            el._skeletonTimeout = setTimeout(hideSkeleton, newConfig.delay)
          } else {
            hideSkeleton()
          }
        }
      }
    })
  },

  // Vue 3 对应 unmounted
  unmounted(el) {
    // 使用requestAnimationFrame确保卸载性能
    requestAnimationFrame(() => {
      if (el._skeletonTimeout) {
        clearTimeout(el._skeletonTimeout)
      }
      if (el._skeleton) {
        el.removeChild(el._skeleton)
        delete el._skeleton
        delete el._skeletonConfig
        delete el._skeletonTimeout
      }
      el.style.overflow = ''
      el.classList.remove('skeleton-parent')
    })
  },

  // Vue 3 可选的 beforeUnmount 钩子（对应 Vue 2 的 beforeDestroy）
  beforeUnmount(el) {
    // 如果需要组件卸载前执行某些操作
  }
}

// 在 Vue 3 中注册指令
// 在 main.js 或组件中使用：
// import { createApp } from 'vue'
// const app = createApp(App)
// app.directive('skeleton', skeletonDirective)

export default skeletonDirective
